(function () {
  if (window.__priceRequestFormHookInstalled) return;
  window.__priceRequestFormHookInstalled = true;
  window.__priceRequestProductData = null;

  var SUBMISSION_URL = /forms\.shopifyapps\.com\/api\/v2\/form_submission/i;
  var TITLE_KEY = 'custom#produkttitel';
  var URL_KEY = 'custom#produkt-url';

  function patchFormSubmissionBody(body) {
    var productData = window.__priceRequestProductData;
    if (!productData || body == null) return body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (productData.title) body.set(TITLE_KEY, productData.title);
      if (productData.url) body.set(URL_KEY, productData.url);
      return body;
    }

    if (typeof body !== 'string') return body;

    try {
      var payload = JSON.parse(body);
      if (productData.title) payload[TITLE_KEY] = productData.title;
      if (productData.url) payload[URL_KEY] = productData.url;
      return JSON.stringify(payload);
    } catch (error) {
      var next = body;
      if (productData.title) {
        next = next.replace(/("custom#produkttitel"\s*:\s*)(""|null)/g, '$1' + JSON.stringify(productData.title));
      }
      if (productData.url) {
        next = next.replace(/("custom#produkt-url"\s*:\s*)(""|null)/g, '$1' + JSON.stringify(productData.url));
      }
      return next;
    }
  }

  function patchRequest(url, body) {
    if (!SUBMISSION_URL.test(String(url || ''))) return body;
    return patchFormSubmissionBody(body);
  }

  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    init = init ? Object.assign({}, init) : {};
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';

    if (SUBMISSION_URL.test(url)) {
      if (init.body != null) {
        init.body = patchRequest(url, init.body);
        return nativeFetch.call(this, input, init);
      }

      if (input instanceof Request && input.body) {
        var request = input.clone();
        return request.text().then(function (text) {
          var patched = patchRequest(url, text);
          return nativeFetch.call(window, new Request(input, { body: patched }), init);
        });
      }
    }

    return nativeFetch.call(this, input, init);
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__priceRequestFormUrl = url;
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (body != null) {
      body = patchRequest(this.__priceRequestFormUrl || '', body);
    }
    return nativeSend.call(this, body);
  };
})();
